import MovementEntity from './MovementEntity';
import { translate as statesTranslate, select as statesFilter, states } from './MovementStates';
import { translate as typesTranslate, select as typesFilter, types } from './MovementTypes';
import { translate as subTypesTranslate, select as subTypesFilter, types as subTypes } from './MovementSubTypes';
import { StatesColors } from '@arredo/reactjs-ui';

export const detailColumns = [
  {
    id: "refId",
    label: "SKU",
  },
  {
    id: "name",
    label: "Descripcion",
  },
  {
    id: "colorCode",
    label: "Color",
  },
  {
    id: "quantity",
    label: "Cantidad",
    align: "center",
    sort: true,
  },
  {
    id: { key1: "adjustmentTypes", key2: "description" },
    label: "Tipo de ajuste",
    align: "center",
    sort: true,
  },
];

export const suggestedReasons = [
  "Auditoria-Egreso",
  "Auditoria-Ingreso",
  "Venta",
  "Venta - Cambio de productos",
  "Venta - Devolución",
  "Venta Anulada",
  "Venta con Cambio",
  "Venta confirmada",
  "Venta devuelta",
]

export const columns = [
  {
    field: "id",
    header: "Id",
    sizes: { xs: 1 },
  },
  {
    field: "number",
    header: "Nro Comprobante",
    sizes: { xs: 2 },
  },
  {
    field: "type",
    translate: (value) => typesTranslate[value],
    header: "Tipo",
    sizes: { xs: 1 },
  },
  {
    field: "subType",
    translate: (value) => subTypesTranslate[value],
    header: "Sub Tipo",
    sizes: { xs: 1 },
  },
  {
    field: "state",
    translate: (value) => statesTranslate[value],
    header: "Estado",
    type: 'chip',
    sx: (row) => StatesColors[row.state],
    sizes: { xs: 1 }
  },
  {
    field: "reason",
    header: "Motivo",
    sizes: { xs: 3 },
  },
  {
    field: "created",
    header: "Fecha",
    type: "date",
    sizes: { xs: 2 },
  },
];

export const columnsReception = [
  {
    id: "refId",
    label: "SKU"
  },
  {
    id: "name",
    label: "Descripcion"
  },
  {
    id: "colorCode",
    label: "Color"
  },
  {
    id: "quantity",
    label: "Cantidad",
    align: "center",
    sort: true
  },
  {
    id: "plannedQuantity",
    label: "Planificada",
    align: "center",
    sort: true
  },
  {
    id: "differenceToShow",
    label: "Diferencia",
    align: "center",
    sort: true
  }
];

export const columnsAdjustment = [
  {
    id: "refId",
    label: "SKU"
  },
  {
    id: "name",
    label: "Descripcion"
  },
  {
    id: "colorCode",
    label: "Color"
  },
  {
    id: "quantity",
    label: "Cantidad",
    align: "center",
    sort: true
  },
  {
    id: { key1: "adjustmentTypes", key2: "description" },
    label: "Tipo de ajuste",
    align: "center",
    sort: true
  }
];

export {
  statesFilter,
  statesTranslate,
  typesFilter,
  typesTranslate,
  subTypesFilter,
  subTypesTranslate,
  states,
  types,
  subTypes
}

export default MovementEntity